exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2pmB8sTE3ARelMbjmqhulZ{width:300px}html[dir] ._2pmB8sTE3ARelMbjmqhulZ{background-color:\"[theme:white, default:#ffffff]\"}._3VnFJmdiw5inZtLPYd3uzm{-webkit-animation:none!important;animation:none!important}.HZb11TDA8N1jEga3INRfm{max-height:470px;overflow-x:hidden}._1VzatE3bfH2MBzxQB5ue1_{overflow:hidden}", ""]);

// exports
exports.locals = {
	"callout": "_2pmB8sTE3ARelMbjmqhulZ",
	"animationStop": "_3VnFJmdiw5inZtLPYd3uzm",
	"scrollContainer": "HZb11TDA8N1jEga3INRfm",
	"recipientCollection": "_1VzatE3bfH2MBzxQB5ue1_"
};